import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export interface LocationTabState {
  activeTab?: string;
}

const isKnownTab = <TabId extends string>(
  tabIds: readonly TabId[],
  tab: unknown,
): tab is TabId => typeof tab === "string" && tabIds.includes(tab as TabId);

/** Tab state that can be preset by navigating with `state: { activeTab }` (e.g. from global search). */
export const useLocationTab = <TabId extends string>(
  tabIds: readonly TabId[],
  defaultTab: TabId,
) => {
  const location = useLocation();
  const requestedTab = (location.state as LocationTabState | null)?.activeTab;

  const [activeTab, setActiveTab] = useState<TabId>(() =>
    isKnownTab(tabIds, requestedTab) ? requestedTab : defaultTab,
  );

  useEffect(() => {
    if (isKnownTab(tabIds, requestedTab)) {
      setActiveTab(requestedTab);
    }
  }, [location.key, requestedTab, tabIds]);

  return [activeTab, setActiveTab] as const;
};
